<template>
    <div class="dl-wrap">
        <div class="dl-container">
            <el-header style="width: 100%">
              <language-switch />
            </el-header>
            <div class="dl-content-base">
                <img src="../../assets/img/h3.jpg" alt="img">
                <div class="dl-base-title">{{getLanguageValue('户用屋面')}}</div>
            </div>
            <div class="dl-content-item">
                <div class="dl-item-count">
                    <el-form ref="form" :model="formBase" :rules="generateRules()" label-position="right" :label-width="formLabelWidth"  :validate-on-rule-change="false">
                        <el-row>
                            <el-col :span="12">
                              <div class="handle-imgs">
                                <el-radio v-model="formBase.type" label="1" class="handle-radio">{{getLanguageValue('斜屋顶')}}</el-radio>
                              </div>
                              <div class="handle-imgs">
                                <img src="../../assets/img/h4.jpg" alt="img">
                              </div>
                                <el-form-item :label="getLanguageValue('组件产品')"   prop="viewProduct">
                                  <div class="row-select-product flex-row">
                                    <el-select v-model="formBase.componentId" style="width: 180px;" clearable :placeholder="getLanguageValue('请选择产品名称')">
                                      <el-option
                                        v-for="item in componentList"
                                        :key="item.id"
                                        :label="item.componentName"
                                        :value="item.id"
                                      >
                                      </el-option>
                                    </el-select>

                                    <el-select v-model="formBase.componentPowerId" style="width: 180px;" clearable :placeholder="getLanguageValue('请选择功率(W)')">
                                      <el-option
                                        v-for="item in componentPowerList"
                                        :key="item.id"
                                        :label="`${item.componentPower}W`"
                                        :value="item.id"
                                      >
                                      </el-option>
                                    </el-select>
                                    <el-button type="warning" @click="createNewProduct">{{getLanguageValue('新建')}}</el-button>
                                  </div>
                                </el-form-item>
                                <el-form-item  >
                                    <div class="dl-content-block">
                                        <div class="dl-block-img"><img :src="formBase.listData.imageUrl" alt=""></div>
                                        <div class="dl-block-item">
                                            <div class="dl-block-text">
                                                <div class="dl-text-title">{{getLanguageValue('组件功率')}}:</div>
                                                <div class="dl-text-unit">{{formBase.listData.componentPower || '-'}}W</div>
                                            </div>
                                            <div class="dl-block-text">
                                                <div class="dl-text-title">{{getLanguageValue('电池类型')}}:</div>
                                                <div class="dl-text-unit">{{formBase.listData.batterShow || '-'}}</div>
                                            </div>
                                            <div class="dl-block-text">
                                                <div class="dl-text-title">{{getLanguageValue('单/双玻')}}:</div>
                                                <div class="dl-text-unit">{{getLanguageValue(formBase.listData.singleDou || '-')}}</div>
                                            </div>
                                            <div class="dl-block-text">
                                                <div class="dl-text-title">{{getLanguageValue('组件寿命')}}:</div>
                                                <div class="dl-text-unit">{{formBase.listData.lifeTime}}{{getLanguageValue('年')}}</div>
                                            </div>
                                            <div class="dl-block-text">
                                                <div class="dl-text-title">{{getLanguageValue('组件长度')}}:</div>
                                                <div class="dl-text-unit">{{formBase.listData.componentHigh || '-'}}m</div>
                                            </div>
                                            <div class="dl-block-text">
                                                <div class="dl-text-title">{{getLanguageValue('组件宽度')}}:</div>
                                                <div class="dl-text-unit">{{formBase.listData.componentWidth || '-'}}m</div>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                              <div class="handle-imgs">
                                <el-radio v-model="formBase.type" label="2" class="handle-radio">{{getLanguageValue('平屋顶')}}</el-radio>
                              </div>
                              <div class="handle-imgs">
                                <img src="../../assets/img/h5.jpg" alt="img">
                              </div>
                                <el-form-item :label="getLanguageValue('组件价格(元/瓦)')"   prop="price">
                                    <el-input class="handle-input" v-model="formBase.price" 
                                      :placeholder="`${getLanguageValue('建议价格')}${formBase.listData.componentPrice}${getLanguageValue('元/瓦')}`"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('省份')"   prop="province">
                                    <el-select @change="changeProvince" class="handle-select" v-model="formBase.province" clearable :placeholder="getLanguageValue('请选择')">
                                        <el-option
                                            v-for="item in formBase.optionProvince"
                                            :key="item.province"
                                            :label="getLanguageValue(item.province)"
                                            :value="item.province">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('城市')"   prop="city">
                                    <el-select class="handle-select" v-model="formBase.city" clearable :placeholder="getLanguageValue('请选择')">
                                        <el-option
                                            v-for="item in formBase.optionCity"
                                            :key="item.city"
                                            :label="getLanguageValue(item.city)"
                                            :value="item.city">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('屋面长度(米)')"   prop="roofLength">
                                    <el-input  class="handle-input" v-model="formBase.roofLength" :placeholder="getLanguageValue('请输入内容')" ></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('屋面宽度(米)')"   prop="roofWidth">
                                    <el-input  class="handle-input" v-model="formBase.roofWidth" :placeholder="getLanguageValue('请输入内容')"></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('组件安装倾角(°)')"   prop="angle">
                                  <el-tooltip  effect="dark" :content="`备注：最佳倾角 ${bestDip}°`" :value="!!bestDip" placement="right" :manual="true">
                                    <el-input-number v-model="formBase.angle" :min="0" :max="45"></el-input-number>
                                  </el-tooltip>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('光伏发电自用比例(%)')"   prop="scale">
                                    <el-input  class="handle-input" v-model="formBase.scale" :placeholder="getLanguageValue('请输入内容')"></el-input>
                                </el-form-item>
                                
                                <el-form-item :label="getLanguageValue('是否自定义自用电价')"  prop="hasSelfUsePrice">
                                  <el-select class="handle-select" v-model="formBase.hasSelfUsePrice" clearable :placeholder="getLanguageValue('请选择')">
                                    <el-option :label="getLanguageValue('是')" value="是"></el-option>
                                    <el-option :label="getLanguageValue('否')" value="否"></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item v-if="formBase.hasSelfUsePrice === '是'" :label="getLanguageValue('自定义自用电价')"   prop="selfUsePrice">
                                    <el-input  class="handle-input" type="number" v-model="formBase.selfUsePrice" :placeholder="getLanguageValue('请输入自定义自用电价')"></el-input>
                                </el-form-item>
                                
                                <el-form-item :label="getLanguageValue('是否自定义上网电价')"  prop="hasInternetPrice">
                                  <el-select class="handle-select" v-model="formBase.hasInternetPrice" clearable :placeholder="getLanguageValue('请选择')">
                                    <el-option :label="getLanguageValue('是')" value="是"></el-option>
                                    <el-option :label="getLanguageValue('否')" value="否"></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item v-if="formBase.hasInternetPrice === '是'" :label="getLanguageValue('自定义上网电价')"   prop="internetPrice">
                                    <el-input  class="handle-input" type="number" v-model="formBase.internetPrice" :placeholder="getLanguageValue('请输入自定义上网电价')"></el-input>
                                </el-form-item>
                                
                                <el-form-item :label="getLanguageValue('建设投资计算方式')"  prop="investMethod">
                                  <el-select class="handle-select" v-model="formBase.investMethod" clearable :placeholder="getLanguageValue('请选择')">
                                    <el-option :label="getLanguageValue('自动计算')" value="自动计算"></el-option>
                                    <el-option :label="getLanguageValue('用户填写')" value="用户填写"></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item  v-if="formBase.investMethod === '用户填写'"  :label="getLanguageValue('建设投资(元/瓦)')"   prop="investPrice">
                                    <el-input  class="handle-input" type="number" v-model="formBase.investPrice" :placeholder="getLanguageValue('请输入')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">&nbsp;</el-col>
                            <el-col :span="12">
                                <el-form-item class="center">
                                    <el-button type="warning" @click="getFormCount('form')" :loading="loadingCount">{{loadingCount? getLanguageValue('计算中') : getLanguageValue('开始计算')}}</el-button>
                                    <el-button @click="handleReload">{{getLanguageValue('重置')}}</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                
                <div v-show="showResult" class="dl-item-result">
                    <el-divider content-position="left">{{getLanguageValue('计算结果')}}</el-divider>
                    <div class="dl-item-list">
                        <el-form label-position="top">
                            <el-col :span="6">
                                <el-form-item :label="getLanguageValue('组件数量(块)')">
                                    <el-input  class="handle-input-item" v-model="formResult.componentNum" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('25年发电利润总额(万)')">
                                    <el-input  class="handle-input-item" v-model="formResult.totalProfit" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('25年总发电量(万kWh)')">
                                    <el-input  class="handle-input-item" v-model="formResult.grossGeneration" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('减排硫氧化物排放量(吨)')">
                                    <el-input  class="handle-input-item" v-model="formResult.reductionSo" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item :label="getLanguageValue('装机容量(千瓦)')">
                                    <el-input  class="handle-input-item" v-model="formResult.installedCapacity" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('全部投资内部收益率(%)')">
                                    <el-input  class="handle-input-item" v-model="formResult.investInternalRate" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('25年年均发电量(万kWh)')">
                                    <el-input  class="handle-input-item" v-model="formResult.avgGeneration" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('减排氮氧化物排放量(吨)')">
                                    <el-input  class="handle-input-item" v-model="formResult.reductionNo" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item :label="getLanguageValue('建设投资(万)')">
                                    <el-input  class="handle-input-item" v-model="formResult.investBulid" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('首年等效利用小时数(H)')">
                                    <el-input  class="handle-input-item" v-model="formResult.firstEqualHours" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('减排标准煤消耗量(吨)')">
                                    <el-input  class="handle-input-item" v-model="formResult.reductionCoal" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('减排灰尘排放量(吨)')">
                                    <el-input  class="handle-input-item" v-model="formResult.reductionDust" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item :label="getLanguageValue('投资回收期(年)')">
                                    <el-input  class="handle-input-item" v-model="formResult.investPayablePeriod" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('25年年均等效利用小时数(万)')">
                                    <el-input  class="handle-input-item" v-model="formResult.avgEqualHours" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('减排二氧化碳排放量(吨)')">
                                    <el-input  class="handle-input-item" v-model="formResult.reductionCo" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item :label="getLanguageValue('自用电价(元/度)')">
                                    <el-input  class="handle-input-item" v-model="formResult.selfUsePrice" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item :label="getLanguageValue('上网电价(元/度)')">
                                    <el-input  class="handle-input-item" v-model="formResult.internetPrice" placeholder=""></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form>
                    </div>
                    <div class="dl-item-foot">
                        <div class="dl-foot-chart" id="leftChart"></div>
                        <div class="dl-foot-chart" id="rightChart"></div>
                    </div>
                    
                </div>
                
            </div>
        </div>
        <v-foot></v-foot>
        <message-sild :logId="logId"></message-sild>

        <!-- 自定义组件规格新增or编辑 -->
        <create-product-dialog
          :visible.sync="addProductDialog" 
          :detailInfo="editProductInfo"
          @submit="handleEditProduct"
        />
    </div>
</template>

<script>
import {
    ComponentProductList,
    ProvinceData,
    CityData,
    ListResult,
    calUserDipBest,
    getComponentSpecification,
    getComponentPower,
} from '@/api/index';
import vFoot from '../../components/foot-box.vue';
import MessageSild from '../../components/Message.vue';
import CreateProductDialog from './components/CreateProductDialog'
import LanguageSwitch from '../../components/language-switch'
import { mapGetters } from "vuex";

export default {
    inject: ['reload'],
    components:{
        vFoot,
        MessageSild,
        CreateProductDialog,
        LanguageSwitch,
    },
    computed: {
      ...mapGetters("language", ["getLanguageValue"])
    },
    watch: {
      'formBase.type': 'calculationDipBest',
      'formBase.city': 'calculationDipBest',
      'formBase.listData.singleDou': 'calculationDipBest',
      'formBase.componentId': 'getComponentPowerList',
      'formBase.componentPowerId': {
        handler(val) {
          const listData_ = this.formBase?.listData || {}
          // 清空功率选择时，已选择自定义产品 不处理
          if(!val && listData_.id && `${listData_.id}`.startsWith('custom-')) {
            return
          }
          const { componentPowerList } = this
          const listData = componentPowerList.find(item => item.id === val) || {}
          this.$set(this.formBase, 'listData', listData)
          this.$set(this.formBase, 'viewProduct', listData?.id || '')
          if(val) this.$set(this.formBase, 'price', listData?.componentPrice || '')
        },
        immediate: true,
      }
    },
    data() {
        return {
            loadingCount:false,
            bestDip: '', // 最佳倾角
            formBase:{
                type:'1',//户用屋面 类型
                viewProduct:"", //组件产品id
                listData:{},
                price:"", //组件价格
                province:"", //省份
                optionProvince:[],
                city:"", //城市
                optionCity:[],
                roofLength:"", //屋面长度
                roofWidth:"", //屋面宽度
                angle:"0", //组件安装倾角
                scale:"", //光伏发电自用比例
                hasSelfUsePrice:"否", // 是否自定义自用电价
                hasInternetPrice: "否", // 是否自定义上网电价
                investMethod: "自动计算", // 建设投资计算方式
            },
            showResult:false,
            formResult:{},
            formLabelWidth:'180px',

            // 是否新建产品
            addProductDialog: false,
            editProductInfo: {},
            logId: '', // 咨询id

            componentList: [], // 组件名称列表
            componentPowerList: [], // 组件功率列表
        };
    },
    created(){
      if(document.body.clientWidth <= 1920){
        this.formLabelWidth = '180px';
      }else if(document.body.clientWidth > 1920){
        this.formLabelWidth = '360px';
      }
      this.getComponentList()
    },
    mounted() {
      this.getProvdiceData();
    },

    methods: {
      /**
       * 获取组件名称列表
       */
      getComponentList() {
        getComponentSpecification('cal-out-user').then(res => {
          this.componentList = res?.data || []
          this.$set(this.formBase, 'componentId', this.componentList.length > 0
          ? this.componentList[0].id
          : '')
        })
      },
      /**
       * 获取组件功率列表
       */
      getComponentPowerList() {
        const { componentList } = this
        const componentId = this.formBase?.componentId || ''
        const componentName = componentList.find(item => item.id === componentId)?.componentName || ''
          // 清空产品名称选择
        if(!componentId) {
          this.componentPowerList = []
          // 清空功率选择
          this.$set(this.formBase, 'componentPowerId', '')
          if(this.formBase.viewProduct && this.formBase.viewProduct.startsWith('custom-')) return
          this.$set(this.formBase, 'viewProduct', '')
          return
        }
        getComponentPower('cal-out-user', { componentName }).then(res => {
          this.componentPowerList = res?.data || []
          this.$set(this.formBase, 'componentPowerId', this.componentPowerList.length > 0
          ? this.componentPowerList[0].id
          : '')
          if(this.formBase.viewProduct && this.formBase.viewProduct.startsWith('custom-')) return
          // 回填组件价格
          this.$set(this.formBase, 'price', this.componentPowerList.length > 0
          ? this.componentPowerList[0].componentPrice
          : '')
          // 回填组件规格
          this.$set(this.formBase, 'viewProduct', this.componentPowerList.length > 0
          ? this.componentPowerList[0].componentStandard
          : '')
        })
      },
      /**
       * 计算最佳倾角
       */
      async calculationDipBest() {
        // 屋顶类型
        const roofType = this.formBase?.type || ''
        // 省份
        const province = this.formBase?.province || ''
        // 城市
        const city = this.formBase?.city || ''
        // 单/双玻
        const singleDou = this.formBase?.listData?.singleDou || ''

        if(!roofType || !city || !singleDou) {
          this.bestDip = ''
          return
        }
        // 斜屋面不展示最佳倾角
        if(roofType === '1') {
          this.bestDip = ''
          return
        }
        calUserDipBest({
          roofType: roofType == '1'?'斜屋面':'平屋面',
          province,
          city,
          singleDou
         }).then(res => {
          if(res.success) this.bestDip = res.data
          else this.bestDip = ''
         }).catch(() => {
          this.bestDip = ''
         })
      },
      generateRules() {
        return {
              // type:[{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              viewProduct:[{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              price:[{ required: true, message: '请输入组件价格', trigger: 'blur' },{ pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: '请输入正确的数值' }],
              province:[{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              city:[{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              roofLength:[
                  { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
                  { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: this.getLanguageValue('请输入正确的数值') }
              ],
              roofWidth:[
                  { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
                  { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: this.getLanguageValue('请输入正确的数值') }
              ],
              angle:[{ required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' }],
              scale:[
                  { required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' },
                  { pattern: /^(\d{0,9})(\.(\d{0,6}))?$/g, message: this.getLanguageValue('请输入正确的数值') }
              ],
              hasSelfUsePrice: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              selfUsePrice: [{ required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' }],
              hasInternetPrice: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              internetPrice: [{ required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' }],
              investMethod: [{ required: true, message: this.getLanguageValue('请选择'), trigger: 'change' }],
              investPrice: [{ required: true, message: this.getLanguageValue('请输入'), trigger: 'blur' }]
            }
      },
      /**
       * 处理计算重置
       */
      handleReload() {
        this.logoId = ''
        this.reload() 
      },
      /**
       * 选择产品
       * @param {Object} info 选择产品信息
       */
      handleEditProduct(info) {
        const id = `custom-${Date.now()}`
        this.$set(this.formBase, 'listData', Object.assign({}, info, { id }))
        this.$set(this.formBase, 'viewProduct', id)
        this.$set(this.formBase, 'componentId', '')
        this.$set(this.formBase, 'componentPowerId', '')
        this.$set(this.formBase, 'price', info.componentPrice)
        this.$refs.form.validateField('viewProduct')
      },
      // 新建产品
      createNewProduct() {
        // this.editProductInfo = {}
        this.addProductDialog = true
      },
      editCustomProduct(info) {
        // this.editProductInfo = info
        this.addProductDialog = true
      },
        getProvdiceData(){
            ProvinceData().then(res=>{
                if(res.success){
                    this.formBase.optionProvince = res.data;
                }
            })
        },
        changeProvince(val){
            this.formBase.city = '';
            CityData({province:val}).then(res=>{
                if(res.success){
                    this.formBase.optionCity = res.data;
                }
            })
        },
        getLeftChart(){
            const LeftChart = this.$echarts.init(document.getElementById('leftChart'));
            const option = {
                title:{
                    text: this.getLanguageValue('营业收入(万元)'),
                    left:'center',
                    textStyle:{
                        fontSize:'22',
                        color:'#505050',
                        fontWeight:'normal',
                    }
                },
                tooltip: {
                    trigger: "axis",
                },
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    // name: "年",
                    // nameTextStyle: {
                    //     color: '#505050',
                    //     fontSize:16,
                    // },
                    data: [1, 2, 3, 4, 5, 6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],
                    axisPointer: {
                        type: 'shadow'
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize: 16,
                            color: '#505050',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    name: this.getLanguageValue('单位:万元'),
                    nameTextStyle: {
                        color: '#505050',
                        fontSize:'16',

                    },
                    axisLabel: {//y轴文字的配置
                        textStyle: {
                            fontSize:16,
                            color: "#505050",//Y轴内容文字颜色
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {//y轴线的配置
                        show: false,
                        lineStyle: {
                            color: "#505050",
                            width: 1,//y轴线的宽度
                            type: "solid"//y轴线为实线
                        },
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            width: 0.5,
                            color: 'rgba(255, 255, 255, 0.4)',
                            type: 'dashed'
                        }
                    },
                },
                series: [
                    {
                        data: this.formResult.busIncomeList,
                        name: this.getLanguageValue('营业收入'),
                        type: 'bar',
                        barWidth: '15px',
                        itemStyle: {
                            color: '#2BA8CD'
                        },
                    }
                ]
            };
            LeftChart.setOption(option);
        },
        getRightChart(){
            const RightChart = this.$echarts.init(document.getElementById('rightChart'));
            const option = {
                title:{
                    text: this.getLanguageValue('累计所得税后净现金流量'),
                    left:'center',
                    textStyle:{
                        fontSize:'22',
                        color:'#505050',
                        fontWeight:'normal',
                    }
                },
                tooltip: {
                    trigger: "axis",
                },
                grid: {
                    left: "3%",
                    right: "5%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    // name: "年",
                    // nameTextStyle: {
                    //     color: '#505050',
                    //     fontSize:16,
                    // },
                    data: [1, 2, 3, 4, 5, 6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],
                    axisPointer: {
                        type: 'shadow'
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize: 16,
                            color: '#505050',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    name: this.getLanguageValue('单位:万元'),
                    nameTextStyle: {
                        color: '#505050',
                        fontSize:16,
                    },
                    axisLabel: {//y轴文字的配置
                        textStyle: {
                            fontSize:16,
                            color: "#505050",//Y轴内容文字颜色
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {//y轴线的配置
                        show: false,
                        lineStyle: {
                            color: "#505050",
                            width: 1,//y轴线的宽度
                            type: "solid"//y轴线为实线
                        },
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            width: 0.5,
                            color: 'rgba(255, 255, 255, 0.4)',
                            type: 'dashed'
                        }
                    },
                },
                series: [
                    {
                        data: this.formResult.afterTaxAddList,
                        name: this.getLanguageValue('累计所得税后净现金流量'),
                        type: 'bar',
                        barWidth: '15px',
                        itemStyle: {
                            color: '#2BA8CD'
                        },
                    }
                ]
            };
            RightChart.setOption(option);
        },
        getFormCount(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    console.log('error submit!!');
                    return;
                }else{
                    this.getFormCount1();
                }
            });
        },
        getFormCount1(){
          this.loadingCount = true;
          const { hasSelfUsePrice, hasInternetPrice, investMethod } = this.formBase
          const info = this.formBase?.listData || {}
          let data = {
              componentSpecification: info.componentStandard || '',
              componentPrice1:this.formBase.price,
              province:this.formBase.province,
              city:this.formBase.city,
              roofType:this.formBase.type == '1'?'斜屋面':'平屋面',
              roofLength:this.formBase.roofLength,
              roofWidth:this.formBase.roofWidth,
              componentInclination:String(this.formBase.angle),
              electricityAutoRate:this.formBase.scale,
              pcPhone:"1",//(备注1pc  2手机)
              hasSelfUsePrice,
              selfUsePrice: hasSelfUsePrice === '是' ? this.formBase.selfUsePrice : '',
              hasInternetPrice,
              internetPrice: hasInternetPrice === '是' ? this.formBase.internetPrice : '',
              investMethod,
              investPrice: investMethod === '用户填写' ? this.formBase.investPrice : ''
          }
          data.component = Object.assign({}, info, { id: info && String(info.id).startsWith('custom-') ? null : info.id })
          ListResult(data).then(res=>{
              if(res.code == "200"){
                  this.loadingCount = false;
              }
              if(res.success){
                  this.logId = res.data.logId
                  this.showResult = true;
                  this.formResult = res.data;
                  this.$nextTick(()=>{
                      this.getLeftChart();
                      this.getRightChart();
                  })
              }else{
                this.$message.error(this.getLanguageValue(res?.message || '计算错误'));
              }
          })   
        }
      }
    }
</script>

<style lang="less" scoped>
.handle-input-item{
    width:240px;
}
// @import '../../assets/css/style.less';
// .dl-container{
//     cursor:default;
//     .dl-content-base{
//         width:100%;
//         height:850px;
//         position:relative;
//         img{
//             position: absolute;
//             z-index:1;
//             width:100%;
//             height:100%;
//         }
//         .dl-base-title{
//             position: absolute;
//             z-index:9;
//             width:100%;
//             height:100%;
//             font-size:60px;
//             font-weight:bold;
//             text-align: center;
//             line-height:850px;
//             color:#fff;
//             letter-spacing: 5px;
//             background-color:rgba(0, 0, 0,0.3);
//         }
//     }
//     .dl-content-item{
//         width:80%;
//         height:100%;
//         margin:10px auto;
//         // background-color:#f00;
//         img{
//             width:600px;
//             height:400px;
//         }
//         .dl-content-block{
//             display: flex;
//             width:500px;
//             height:300px;
//             // background-color:#f0f;
//             .dl-block-img{
//                 // flex:1;
//                 width:35%;
//                 height:100%;
//                 background-color:#ff0;
//             }
//             .dl-block-item{
//                 flex:1;
//                 width:65%;
//                 height:100%;
//                 // background-color: #f00;
//                 .dl-block-text{
//                     display: flex;
//                     width:100%;
//                     height:50px;
//                     line-height:50px;
//                     .dl-text-title{
//                         width:40%;
//                         font-size:20px;
//                         font-weight:bold;
//                         color:#5D5D5D;
//                         text-align: right;
//                     }
//                     .dl-text-unit{
//                         flex:1;
//                         width:50%;
//                         margin-left:5px;
//                         font-size:18px;
//                         color:#545454;
//                     }
//                 }
//             }
//         }
//         .dl-result{
//             width:100%;
//             height:400px;
//         }
//         .dl-content-foot{
//             display: flex;
//             width:100%;
//             height:350px;
//             // background-color:#f0f;
//             .dl-foot-chart{
//                 flex:1;
//                 // background-color:#f00;
//             }
//         }
//     }
// }

.handle-input{
    width:280px;
}
.handle-select{
	width:280px;
}
.handle-imgs{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  margin-bottom: 16px;
}
.handle-radio{
    margin-left:50px;
}

.edit-product {
  color: #5CB6FF !important;
  margin-left: 5px;
}

.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.row-select-product {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
}
</style>